import { render, staticRenderFns } from "./FollowupSettings.vue?vue&type=template&id=d35e71aa&scoped=true"
import script from "./FollowupSettings.vue?vue&type=script&lang=js"
export * from "./FollowupSettings.vue?vue&type=script&lang=js"
import style0 from "./FollowupSettings.vue?vue&type=style&index=0&id=d35e71aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35e71aa",
  null
  
)

export default component.exports